export var validBaseUrl = 'https://baseUrl';
//# sourceMappingURL=valid-base-url.js.map